export default __webpack_public_path__ + "static/media/b.8eba5f10.mp4";